@if (this.hasContent) {
<nav class="avatar-fullscreen-header">
    <div class="header-slot header-slot-left">
        @if (this.header()?.left?.kind === 'image') {
        <img
            [src]="this.header()!.left.value"
            alt=""
        >
        } @else if (this.header()?.left?.kind === 'text') {
        <span>{{ this.header()!.left.value }}</span>
        }
    </div>
    <div class="header-slot header-slot-center">
        @if (this.header()?.center?.kind === 'image') {
        <img
            [src]="this.header()!.center.value"
            alt=""
        >
        } @else if (this.header()?.center?.kind === 'text') {
        <span>{{ this.header()!.center.value }}</span>
        }
    </div>
    <div class="header-slot header-slot-right">
        @if (this.header()?.right?.kind === 'image') {
        <img
            [src]="this.header()!.right.value"
            alt=""
        >
        } @else if (this.header()?.right?.kind === 'text') {
        <span>{{ this.header()!.right.value }}</span>
        }
    </div>
</nav>
}